import React, { useState, useEffect } from 'react';

const ExperienceForm = ({ experience, onSave, onCancel }) => {
  const [formData, setFormData] = useState({
    company: '',
    role: '',
    period: '',
    location: '',
    description: ''
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (experience) {
      setFormData({
        ...experience,
        description: Array.isArray(experience.description) 
          ? experience.description.join('\n') 
          : experience.description
      });
    }
  }, [experience]);

  const validateForm = () => {
    const newErrors = {};

    if (!formData.company.trim()) {
      newErrors.company = 'Company name is required';
    }

    if (!formData.role.trim()) {
      newErrors.role = 'Role is required';
    }

    if (!formData.period.trim()) {
      newErrors.period = 'Period is required';
    }

    if (!formData.location.trim()) {
      newErrors.location = 'Location is required';
    }

    if (!formData.description.trim()) {
      newErrors.description = 'Description is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      onSave({
        ...formData,
        description: formData.description.split('\n').filter(d => d.trim())
      });
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <h3>{experience ? 'Edit Experience' : 'Add New Experience'}</h3>

      <div className="form-group">
        <label htmlFor="company">Company</label>
        <input
          id="company"
          type="text"
          name="company"
          value={formData.company}
          onChange={handleChange}
          placeholder="e.g., Tech Company A"
        />
        {errors.company && <div style={{ color: '#d32f2f', fontSize: '12px', marginTop: '5px' }}>{errors.company}</div>}
      </div>

      <div className="form-group">
        <label htmlFor="role">Role</label>
        <input
          id="role"
          type="text"
          name="role"
          value={formData.role}
          onChange={handleChange}
          placeholder="e.g., Senior Developer"
        />
        {errors.role && <div style={{ color: '#d32f2f', fontSize: '12px', marginTop: '5px' }}>{errors.role}</div>}
      </div>

      <div className="form-group">
        <label htmlFor="period">Period</label>
        <input
          id="period"
          type="text"
          name="period"
          value={formData.period}
          onChange={handleChange}
          placeholder="e.g., 2022 - Present"
        />
        {errors.period && <div style={{ color: '#d32f2f', fontSize: '12px', marginTop: '5px' }}>{errors.period}</div>}
      </div>

      <div className="form-group">
        <label htmlFor="location">Location</label>
        <input
          id="location"
          type="text"
          name="location"
          value={formData.location}
          onChange={handleChange}
          placeholder="e.g., Bangkok, Thailand"
        />
        {errors.location && <div style={{ color: '#d32f2f', fontSize: '12px', marginTop: '5px' }}>{errors.location}</div>}
      </div>

      <div className="form-group">
        <label htmlFor="description">Description (One per line)</label>
        <textarea
          id="description"
          name="description"
          value={formData.description}
          onChange={handleChange}
          placeholder="e.g., Led development team&#10;Built scalable applications"
          style={{ width: '100%', padding: '10px', minHeight: '100px', fontFamily: 'inherit', border: '1px solid #ddd', borderRadius: '5px', fontSize: '14px' }}
        />
        {errors.description && <div style={{ color: '#d32f2f', fontSize: '12px', marginTop: '5px' }}>{errors.description}</div>}
      </div>

      <div className="modal-actions">
        <button type="button" className="cancel-btn" onClick={onCancel}>
          Cancel
        </button>
        <button type="submit" className="save-btn">
          {experience ? 'Update Experience' : 'Create Experience'}
        </button>
      </div>
    </form>
  );
};

export default ExperienceForm;
